module.exports = __webpack_public_path__ + "img/bg-mosaic.ca9147ac.png";